module.exports = __webpack_public_path__ + "img/pflanzen.335562b4.svg";